import type { Store } from "@/stores";
import { useMapStoreStateToClientState } from "@/hooks/useMapStoreStateToClientState";

export const useStateOfPreserveFilters = (
  store: Store,
  isRoundTrip: boolean,
) => {
  return useMapStoreStateToClientState(
    store,
    (store: Store) => {
      const pageStore = isRoundTrip
        ? store.appStore.stepByStepSearchPage.currentStepStore
        : store.appStore.completeSearchPage;
      const restoreStore = isRoundTrip
        ? store.appStore.stepByStepSearchPage
        : store.appStore.completeSearchPage;

      return {
        isResourcedFetched: store.appStore.flightInfo.resources.isFetched,
        isLoading: pageStore?.searchResults?.isLoading,
        restorePreservedFilters: restoreStore.restorePreservedFilters,
        preservedFilters: restoreStore.preservedFilters,
        restoreStopFilters: restoreStore.restoreStopFilters,
        restoreAirlineFilters: restoreStore.restoreAirlineFilters,
        restoreBaggageFilters: restoreStore.restoreBaggageFilters,
        restorePriceFilters: restoreStore.restorePriceFilters,
        restoreAirportFilters: restoreStore.restoreAirportFilters,
        restoreTimeFilters: restoreStore.restoreTimeFilters,
        isOutbound: isRoundTrip
          ? store.appStore.stepByStepSearchPage.currentStep === "outbound"
          : true,
      };
    },
    [isRoundTrip],
  );
};
